const blockClass = '.wp-block-ttr-world-map';
// World Map
($ => {

    const colors = {
        northAmerica: '#0067BE',
        southAmerica: '#00B6ED',
        europe: '#FFC94F',
        africa: '#00B6ED',
        middleEast: '#668BAE',
        asia: '#003D78',
        centralAmerica: '#BCDFBA',
        pacific: '#79BE76',
        caribbean: '#685B4C',
        australia: '#306FB7',
        russia: '#c6e7c8'
    };

    const _WMStrokes = function (sel) {
        const args = {
            targets: [sel + ' path', sel + ' polygon'],
            strokeDashoffset: [anime.setDashoffset, 0]
        };
        return args;
    };

    const _WMFillToGray = function (sel, color='#CFCBC8') {
        const args = {
            targets: [sel + ' path:not(.fill)', sel + ' polygon:not(.fill)'],
            fill: ['#FFFFFF', color],
            stroke: ['#000000', '#aaaaaa'],
            duration: 750
        };
        return args;
    };

    const _WMFillToColor = function (sel, color='#306FB7') {
        const args = {
            targets: [sel + ' path.fill', sel + ' polygon.fill'],
            fill: ['#FFFFFF', color],
            stroke: ['#000000', '#aaaaaa'],
            duration: 750
        };
        return args;
    };

    const defaultDur = 1000;
    const defaultDelay = 500;
    const defaultEasing = 'cubicBezier(.17,0,.66,.09)';
    const defaultParams = {
        easing: defaultEasing,
        duration: defaultDur
    };
    const sel = '#world-map';
    const svg = sel + ' #World_Map';
    const tl2 = anime.timeline(defaultParams);

    tl2.add({
        targets: svg,
        opacity: [0, 1],
    })
        .add(_WMStrokes(svg + ' #North_America'))
        .add(_WMStrokes(svg + ' #Central_America'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Caribbean'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #South_America'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Europe'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Africa'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Middle_East'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Pacific'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Asia'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Russia'), '-=' + defaultDelay)
        .add(_WMStrokes(svg + ' #Australia'), '-=' + defaultDelay)
        .add(_WMFillToGray(svg + ' #North_America'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #North_America', colors.northAmerica), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Central_America'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Central_America', colors.centralAmerica), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Caribbean'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Caribbean', colors.caribbean), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #South_America'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #South_America', colors.southAmerica), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Europe'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Europe', colors.europe), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Africa'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Africa', colors.africa), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Middle_East'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Middle_East', colors.middleEast), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Pacific'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Pacific', colors.pacific), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Asia'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Asia', colors.asia), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Russia'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Russia', colors.russia), '-=' + defaultDur)
        .add(_WMFillToGray(svg + ' #Australia'), '-=' + defaultDur)
        .add(_WMFillToColor(svg + ' #Australia', colors.australia), '-=' + defaultDur);

})(jQuery);
